import { ArrowRight } from 'lucide-react';
import { Link, useLocation, useMatch } from 'react-router';

import { AnimatedCard } from '@components/patterns';
import { Button } from '@components/primitives';

export default function NotFound() {
  const { pathname } = useLocation();

  const isAdmin = useMatch('/admin/*');
  const home = isAdmin ? '/admin' : '/';

  return (
    <AnimatedCard className="p-5" style={{ maxWidth: 560, margin: '0 auto' }}>
      <h6 className="mb-2 color-secondary-60">404</h6>
      <h3>Page Not found</h3>
      <p>
        No page found for <code>{pathname}</code>.
      </p>
      <Button asChild>
        <Link to={home}>
          Take me home
          <ArrowRight />
        </Link>
      </Button>
    </AnimatedCard>
  );
}
